import React, { Component } from 'react'
import { Flex } from 'reflexbox'
import { mapProps, compose } from 'recompose'

import { GLOBAL_ROLES, ROUTE_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import { EditIconButton } from 'components/custom/EditIconButton/index'
import Input from './Input'

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      GLOBAL_ROLES.ADMIN_ACCESS,
      ROUTE_ROLES.DATA_MANAGER
    ]
  })),
  showOnAnyRoles
)

const EditButton = showToTeam(EditIconButton)

const Actions = ({searchValue, onSearch, onEdit, edit, toggleCollapse, collapse}) => {
  return (
    <Flex justify='flex-end'>
      <Input
        onChange={onSearch}
        value={searchValue}
      />
      <EditButton
        onClick={onEdit}
        onDoneIcon={'list'}
        edit={edit}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
